import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef, useState } from "react";
import { Button, Form } from "react-bootstrap";
import "./Review_Form.css";
import Success_Toster from "../../../../../../../common/common_modal/success_toster/Success_Toster";
import {
  Create,
  GetAll,
} from "../../../../../../../features/admin/quality_management/process_requirement/tender/Slice";

import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";

function Review_Form({ handleClose }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
    watch,
    getValues,
    control,
  } = useForm();

  const dispatch = useDispatch();

  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [success]);

  const onSubmit = async (data) => {
    try {
      const formData = new FormData();
      formData.append("remark", data.remark);
      // formData.append("approval_note", data.approval_note);
      formData.append("material", data.material);
      formData.append("name_of_tender", data.name_of_tender);
      formData.append("tendor_document", data.tendor_document[0]);

      formData.append("approval_note", data.approval_note[0]);

      const res = await dispatch(Create(formData));

      if (res.meta.requestStatus === "fulfilled") {
        setSuccess(true);
        await dispatch(GetAll());
        reset();
      }
    } catch (err) {
      console.error("Submit error:", err);
    }
  };

  return (
    <section className="Legal_Entity_Form">
      <div className="white_container customer_section">
        <div className="row">
          {/* Customer Name */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Name Of Tender</Form.Label>
              <Form.Control
                placeholder="Enter Name Of Tender"
                {...register("name_of_tender", {
                  required: "Name Of Tender is required",
                })}
              />
              {errors.name_of_tender && (
                <Form.Text className="text-danger">
                  {errors.name_of_tender.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Remark</Form.Label>
              <Form.Control
                placeholder="Enter Remark"
                {...register("remark", {
                  required: "Remark is required",
                })}
              />
              {errors.remark && (
                <Form.Text className="text-danger">
                  {errors.remark.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          {/* Contact Person Name */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Material</Form.Label>
              <Form.Control
                placeholder="Enter Material."
                {...register("material", {
                  required: "Material is required",
                })}
              />
              {errors.material && (
                <Form.Text className="text-danger">
                  {errors.material.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          {/* Contact No */}
          {/* <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Approval Note</Form.Label>
              <Form.Control
                placeholder="Enter Approval Note"
                {...register("approval_note", {
                  required: "Approval Note is required",
                })}
              />{" "}
              {errors.approval_note && (
                <Form.Text className="text-danger">
                  {errors.approval_note.message}
                </Form.Text>
              )}
            </Form.Group>
          </div> */}

          <div className="col-md-4">
            <Form.Group className="form_group file_field">
              <Form.Label>Approval Note</Form.Label>

              <div className="absolute_fields">
                <Form.Control
                  type="file"
                  {...register("approval_note", {
                    required:
                      typeof getValues("approval_note") === "string"
                        ? false
                        : "File is required",
                  })}
                  accept="*"
                />
                <div className="upload_icon_holder">
                  <FontAwesomeIcon icon={faUpload} />
                </div>
                {errors.approval_note && (
                  <span className="text-danger">
                    {errors.approval_note.message}
                  </span>
                )}
              </div>
              {(() => {
                const fileValue = watch("approval_note");

                // URL for preview
                const fileUrl =
                  typeof fileValue === "string"
                    ? process.env.REACT_APP_IMG_URL + fileValue
                    : fileValue?.length > 0
                    ? URL.createObjectURL(fileValue[0])
                    : null;

                // Type detection
                const fileType =
                  typeof fileValue === "string"
                    ? fileValue.toLowerCase()
                    : fileValue?.[0]?.type;

                if (!fileUrl) return null;

                return (
                  <div className="image_holder">
                    {/* IMAGE */}
                    {(fileType?.includes("image") ||
                      fileType?.endsWith(".jpg") ||
                      fileType?.endsWith(".jpeg") ||
                      fileType?.endsWith(".png")) && (
                      <img
                        src={fileUrl}
                        alt="Preview"
                        className="image-preview"
                        style={{ maxWidth: "150px" }}
                      />
                    )}

                    {/* PDF */}
                    {(fileType === "application/pdf" ||
                      fileType?.endsWith(".pdf")) && (
                      <iframe
                        src={fileUrl}
                        // style={{ maxWidth: "100px" }}
                        title="PDF"
                      />
                    )}

                    {/* WORD */}
                    {(fileType?.includes("word") ||
                      fileType?.endsWith(".doc") ||
                      fileType?.endsWith(".docx")) && (
                      <div>
                        <p>Word preview not supported</p>
                        <a
                          href={fileUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Open / Download Word File
                        </a>

                        <iframe
                          src={`https://docs.google.com/gview?url=${fileUrl}&embedded=true`}
                          style={{ maxWidth: "100px" }}
                          title="Word Preview"
                        />
                      </div>
                    )}

                    {/* EXCEL */}
                    {(fileType?.includes("spreadsheet") ||
                      fileType?.endsWith(".xlsx") ||
                      fileType?.endsWith(".xls")) && (
                      <div>
                        <p>Excel preview not supported</p>
                        <a
                          href={fileUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Open / Download Excel File
                        </a>
                      </div>
                    )}
                  </div>
                );
              })()}
              {/* {filePreview && (
                <div className="image_holder">
                  <img
                    src={filePreview}
                    alt="Preview"
                    className="img_preview"
                  />
                </div>
              )} */}
            </Form.Group>
          </div>

          {/* Attach Document */}
          <div className="col-md-4">
            <Form.Group className="form_group file_field">
              <Form.Label>Tendor Document</Form.Label>

              <div className="absolute_fields">
                <Form.Control
                  type="file"
                  {...register("tendor_document", {
                    required:
                      typeof getValues("tendor_document") === "string"
                        ? false
                        : "File is required",
                  })}
                  accept="*"
                />
                <div className="upload_icon_holder">
                  <FontAwesomeIcon icon={faUpload} />
                </div>
                {errors.tendor_document && (
                  <span className="text-danger">
                    {errors.tendor_document.message}
                  </span>
                )}
              </div>
              {(() => {
                const fileValue = watch("tendor_document");

                // URL for preview
                const fileUrl =
                  typeof fileValue === "string"
                    ? process.env.REACT_APP_IMG_URL + fileValue
                    : fileValue?.length > 0
                    ? URL.createObjectURL(fileValue[0])
                    : null;

                // Type detection
                const fileType =
                  typeof fileValue === "string"
                    ? fileValue.toLowerCase()
                    : fileValue?.[0]?.type;

                if (!fileUrl) return null;

                return (
                  <div className="image_holder">
                    {/* IMAGE */}
                    {(fileType?.includes("image") ||
                      fileType?.endsWith(".jpg") ||
                      fileType?.endsWith(".jpeg") ||
                      fileType?.endsWith(".png")) && (
                      <img
                        src={fileUrl}
                        alt="Preview"
                        className="image-preview"
                        style={{ maxWidth: "150px" }}
                      />
                    )}

                    {/* PDF */}
                    {(fileType === "application/pdf" ||
                      fileType?.endsWith(".pdf")) && (
                      <iframe
                        src={fileUrl}
                        // style={{ maxWidth: "100px" }}
                        title="PDF"
                      />
                    )}

                    {/* WORD */}
                    {(fileType?.includes("word") ||
                      fileType?.endsWith(".doc") ||
                      fileType?.endsWith(".docx")) && (
                      <div>
                        <p>Word preview not supported</p>
                        <a
                          href={fileUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Open / Download Word File
                        </a>

                        <iframe
                          src={`https://docs.google.com/gview?url=${fileUrl}&embedded=true`}
                          style={{ maxWidth: "100px" }}
                          title="Word Preview"
                        />
                      </div>
                    )}

                    {/* EXCEL */}
                    {(fileType?.includes("spreadsheet") ||
                      fileType?.endsWith(".xlsx") ||
                      fileType?.endsWith(".xls")) && (
                      <div>
                        <p>Excel preview not supported</p>
                        <a
                          href={fileUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Open / Download Excel File
                        </a>
                      </div>
                    )}
                  </div>
                );
              })()}
              {/* {filePreview && (
                <div className="image_holder">
                  <img
                    src={filePreview}
                    alt="Preview"
                    className="img_preview"
                  />
                </div>
              )} */}
            </Form.Group>
          </div>
        </div>

        {/* Buttons */}
        <div className="permission_btn_holder">
          {success ? (
            <Success_Toster successText="Save Audit Successfully!" />
          ) : (
            <>
              <Button type="button" className="permission_btn No_btn">
                Reset
              </Button>

              <Button
                type="button"
                className="permission_btn Yes_btn"
                // onClick={() => setSuccess(true)}
                onClick={handleSubmit(onSubmit)}
              >
                Save
              </Button>
            </>
          )}
        </div>
        {/* <div className="permission_btn_holder">
          <Button
            type="button"
            className="permission_btn No_btn"
            onClick={handleClose}
          >
            Reset
          </Button>

          <Button type="submit" className="permission_btn Yes_btn">
            Save
          </Button>
        </div> */}
      </div>
    </section>
  );
}

export default Review_Form;
